/**
 * article-toc.js — Enrichment custom script (not a Sleek theme file).
 * Builds the "In This Article" table of contents from the rendered
 * article body's own h2 headings (article.content is author-written
 * rich-text HTML with no heading ids of its own, so there's nothing for
 * Liquid to build a TOC from server-side -- this adds ids and populates
 * the list client-side instead), and highlights whichever section is
 * currently in view via IntersectionObserver.
 *
 * Renders nothing (and the TOC column collapses via CSS :empty) on the
 * ~49 articles with fewer than 2 h2s, or when #ArticleToc isn't present
 * at all -- this script is safe to load on every article page.
 */
(function () {
  var toc = document.getElementById('ArticleToc');
  if (!toc) return;

  var content = document.querySelector('.article__content');
  if (!content) return;

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
  if (headings.length < 2) return; // not worth a TOC for one or two sections

  var list = toc.querySelector('.article__toc-list');
  var usedSlugs = {};

  function slugify(text) {
    var base = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') || 'section';
    var slug = base;
    var i = 2;
    while (usedSlugs[slug]) {
      slug = base + '-' + i;
      i++;
    }
    usedSlugs[slug] = true;
    return slug;
  }

  var links = [];
  headings.forEach(function (heading) {
    if (!heading.id) heading.id = slugify(heading.textContent);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;
    li.appendChild(a);
    list.appendChild(li);
    links.push({ heading: heading, link: li });
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var match = links.find(function (item) {
          return item.heading === entry.target;
        });
        if (!match) return;
        if (entry.isIntersecting) {
          links.forEach(function (item) {
            item.link.classList.remove('is-active');
          });
          match.link.classList.add('is-active');
        }
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );
  headings.forEach(function (heading) {
    observer.observe(heading);
  });
})();
